import { useTranslation } from 'react-i18next';

import { Segmentado } from '#components/mobile/ui/Segmentado';

import { alternarTrato, nombreTrato, TRATOS } from './trato';
import type { Trato } from './trato';

type SelectorTratoProps = {
  /** `null` = sin elegir (ninguna opción marcada). */
  valor: Trato | null;
  onChange: (trato: Trato | null) => void;
  /** Nombre del grupo para los lectores de pantalla. */
  etiqueta: string;
  testId?: string;
};

/**
 * «En femenino · En masculino · En neutro», como en la maqueta: es opcional
 * y tocar la opción marcada la quita (vuelve a «sin elegir»). Lo comparten el
 * paso 0 de la travesía y Ajustes → «Cómo te hablo».
 */
export function SelectorTrato({
  valor,
  onChange,
  etiqueta,
  testId = 'trato',
}: SelectorTratoProps) {
  const { t } = useTranslation();
  return (
    <Segmentado<Trato | ''>
      etiqueta={etiqueta}
      testId={testId}
      estirar
      alto={40}
      valor={valor ?? ''}
      opciones={TRATOS.map(x => ({ valor: x, texto: nombreTrato(t, x) }))}
      onChange={tocada => {
        if (tocada) {
          onChange(alternarTrato(valor, tocada));
        }
      }}
      style={{ borderRadius: 14 }}
    />
  );
}
